var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "loadableModeration",
      staticClass:
        "moderation-wrapper table-wrapper scrollable moderation-table",
      class: _vm.name + "-table",
    },
    [
      _c(
        "div",
        { ref: "loadableModerationContent", staticClass: "moderation-content" },
        [
          _vm.badWordsFeed
            ? _c(
                "ul",
                {
                  staticClass: "moderation-body scrollable",
                  attrs: { id: "moderation-content" },
                },
                _vm._l(_vm.gridData.data, function (item, key) {
                  return _c(
                    "li",
                    {
                      key: key,
                      staticClass: "row post",
                      class: `comment-${key}`,
                    },
                    [
                      _c("comments-post", {
                        key: `comments-${key}`,
                        attrs: {
                          page: item.page,
                          post: item,
                          badWordsFeed: _vm.badWordsFeed,
                          badWordList: _vm.badWordList,
                        },
                        on: {
                          getPosts: _vm.getPosts,
                          addPostLike: _vm.addPostLike,
                          badWordsDetected: _vm.badWordsDetected,
                          deleteCommentWithBadWord:
                            _vm.deleteCommentWithBadWord,
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              )
            : _c(
                "ul",
                {
                  staticClass: "moderation-body scrollable",
                  attrs: { id: "moderation-content" },
                },
                _vm._l(_vm.gridData.data, function (item, key) {
                  return _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "observe-visibility",
                          rawName: "v-observe-visibility",
                          value: {
                            callback: _vm.visibilityChanged,
                            once: true,
                          },
                          expression:
                            "{\n            callback: visibilityChanged,\n            once: true,\n          }",
                        },
                      ],
                      key: key,
                      staticClass: "row post",
                      class: `post-${key}`,
                    },
                    [
                      key <= _vm.numMaxPostLoaded
                        ? _c(
                            "div",
                            {
                              staticClass: "content-post",
                              attrs: { id: `content-post-${key}` },
                            },
                            [
                              !_vm.pins && _vm.checkPins(item)
                                ? _c(
                                    "vs-button",
                                    {
                                      staticClass: "btn-drop pin add",
                                      attrs: { type: "filled" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addPin(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            text: _vm.$t(
                                              "dash.moderation.pins.add"
                                            ),
                                            position: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                "enable-background":
                                                  "new 0 0 24 24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                width: "24",
                                              },
                                            },
                                            [
                                              _c("g", [
                                                _c("rect", {
                                                  attrs: {
                                                    fill: "none",
                                                    height: "24",
                                                    width: "24",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z",
                                                    "fill-rule": "evenodd",
                                                  },
                                                }),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.pins || !_vm.checkPins(item)
                                ? _c(
                                    "vs-button",
                                    {
                                      staticClass: "btn-drop pin remove",
                                      attrs: { type: "filled" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removePin(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            text: _vm.$t(
                                              "dash.moderation.pins.remove"
                                            ),
                                            position: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                "enable-background":
                                                  "new 0 0 24 24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                width: "24",
                                              },
                                            },
                                            [
                                              _c("g", [
                                                _c("rect", {
                                                  attrs: {
                                                    fill: "none",
                                                    height: "24",
                                                    width: "24",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z",
                                                    "fill-rule": "evenodd",
                                                  },
                                                }),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("preview-post", {
                                key: `post-${item.id}`,
                                attrs: {
                                  page: _vm.gridData.pages,
                                  post: _vm.convertToPreview(item),
                                  moderation: true,
                                },
                              }),
                              _c("comments-post", {
                                key: `comments-${item.id}`,
                                attrs: {
                                  page: _vm.gridData.pages,
                                  post: item,
                                  badWordList: _vm.badWordList,
                                },
                                on: {
                                  switchComment: _vm.switchComment,
                                  getPosts: _vm.getPosts,
                                  addPostLike: _vm.addPostLike,
                                  badWordsDetected: _vm.badWordsDetected,
                                  addCountComments: _vm.addCountComments,
                                },
                              }),
                            ],
                            1
                          )
                        : _c("div", {
                            staticClass: "content-post lazyload",
                            attrs: { id: `content-post-${key}` },
                          }),
                    ]
                  )
                }),
                0
              ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }